import React, { useMemo } from 'react';

import { Direction2D, Line2D, Point2D, Point3D } from '@paragon/geometry-library';
import { Point2D as PointObject2D } from '@paragon/three-shared';

import { SimpleSlopeDimension } from '../SimpleSlopeDimension';

interface Props {
  basePoint: PointObject2D;
  mousePosition: PointObject2D;
  showPitchInLabel?: boolean;
}

export function PointSlopeLineInsertionDimension(props: Props) {
  const mousePosition3D = useMemo(
    () => new Point3D(props.mousePosition.x, props.mousePosition.y, 0),
    [props.mousePosition],
  );

  const basePoint = props.basePoint;

  const basePoint3D = useMemo(() => ({ ...basePoint, z: 0 }), [basePoint]);
  const baseLinePoint = useMemo(() => {
    const mousePoint = Point2D.fromObject(props.mousePosition);
    const horizontalLine = new Line2D(Point2D.fromObject(basePoint), Direction2D.right);
    const mouseVerticalLine = new Line2D(mousePoint, Direction2D.down);
    const intersection = horizontalLine.intersectWithLine(mouseVerticalLine)!;

    return intersection.to3D();
  }, [props.mousePosition, basePoint]);

  return (
    <SimpleSlopeDimension
      basePoint={basePoint3D}
      baseLineEndPoint={baseLinePoint}
      endLineEndPoint={mousePosition3D}
      showDegreesInLabel
      showPitchInLabel={props.showPitchInLabel}
    />
  );
}
